//--------------- IMPORTAÇÕES ---------------//
import { useEffect, useContext } from "react";
import { Loading } from "../../shared/components";
import { LoadingContext } from "../../shared/context/LoadingContext";
import { loadGroupsProductsService } from "./services";
import { OrderbumpsContext } from "./context/OrderbumpsContext";
import { Main } from "./components";



//--------------- EXPORTAÇÃO DA PÁGINA ORDERBUMP RELATÓRIO ---------------//
export default function Orderbump() {



  //--------------- CRIAÇÃO DE HOOKS ---------------//
  const { products, setProducts } = useContext(OrderbumpsContext); // Estado que armazena a lista de produtos existentesconst [transactions, setTransactions] = useContext(OrderbumpContext); // Estado que armazena a lista de transações existentes
  const { isLoading, setIsLoading } = useContext(LoadingContext); // Estado que armazena se a tela de carregamento está aparecendo ou não (inicia aparecendo)



  //--------------- USE EFFECT DE INICIALIZAÇÃO ---------------//
  useEffect(() => {
    handleLoadProducts();
  }, []);



  //--------------- FUNÇÃO ASSÍNCRONA HANDLE LOAD PRODUCTS ---------------//
  async function handleLoadProducts() {
    setIsLoading(true);
    const response = await loadGroupsProductsService();
    if(response){
      setProducts(response.data)
    }
    setIsLoading(false);
  }



  //--------------- RETORNO CONDICIONAL DA PÁGINA ORDERBUMP RELATÓRIO ---------------//
  return(
    <>
    {isLoading || !products ? <Loading /> : <Main />}
    </>
  )
}